import NestedRouter from "Router/NestedRouter";
import Cookies from "js-cookie";
import React from "react";

const NestedRouting = ({ GlobalConstants, EntirePageRender }) => {
  return <React.Fragment>{GlobalConstants?.rootPaths?.length > 0 || !Cookies.get("user") ? <div style={{ display: "flex", flexDirection: "column", gap: "5em" }}>{EntirePageRender ? <NestedRouter rootPaths={GlobalConstants?.rootPaths} /> : <NestedRouter rootPaths={GlobalConstants?.rootPaths} />}</div> : <></>}</React.Fragment>;
};

export default NestedRouting;
